module.exports = __webpack_public_path__ + "static/media/fsctx.af72631a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/News/Assets/fsctx.png
// module id = 373
// module chunks = 0